/* V2 CART (Neo, 9 Oct 2026). Small additions to the Kaching cart drawer, done from the theme so no app setting
   changes. Kaching re-renders the drawer whenever the cart changes, so everything is re-applied on each change.
   1. A title over the upsell row ("Make it a double feature"), plus "a second piece ships it free" when that is
      true: the bar still asks for more and the amount left is no more than our cheapest add-on (the €45 cap).
   2. The three promises right under the checkout button; an empty cart gets a way back to the T-shirts.
   3. Upsell images at 400 px instead of 200 px, loaded straight away (lazy loading never fired inside Kaching's row).
   4. The upsell never adds a size nobody picked: Kaching pre-selects the first size (S), so "Add" first asks for a
      size, the same rule as the product page. Listeners sit on window in the capture phase because Kaching handles
      the tap itself. */
(() => {
  const CHEAPEST_ADDON = 45;
  const TRUST = ['Duties covered', '31-day returns', 'Tracked delivery'];
  const touched = new Set();

  const amountLeft = (root) => {
    const bar = root.querySelector('.kaching-cart__tiered-promotions-bar-text');
    if (!bar || !/more/i.test(bar.textContent)) return null;
    const strong = bar.querySelector('strong');
    const n = parseFloat((strong ? strong.textContent : bar.textContent).replace(/[^\d,.]/g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };

  const apply = (root) => {
    const up = root.querySelector('.kaching-upsell-module--product-upsell');
    if (up) {
      let head = up.querySelector(':scope > .v2kc-up');
      if (!head) {
        head = document.createElement('p');
        head.className = 'v2kc-up';
        head.innerHTML = '<span>Make it a double feature</span><span></span>';
        up.prepend(head);
      }
      const left = amountLeft(root);
      const note = left !== null && left <= CHEAPEST_ADDON ? 'A second piece ships it free' : '';
      if (head.lastElementChild.textContent !== note) head.lastElementChild.textContent = note;
      up.querySelectorAll('img.kaching-product-upsell-item__image').forEach((img) => {
        if (img.loading !== 'eager') img.loading = 'eager';
        if (img.src.includes('_200x200.')) img.src = img.src.replace('_200x200.', '_400x400.');
      });
    }
    const emptyTitle = root.querySelector('.kaching-cart__empty-cart-title');
    if (emptyTitle && !(emptyTitle.nextElementSibling && emptyTitle.nextElementSibling.classList.contains('v2kc-empty'))) {
      const box = document.createElement('div');
      box.className = 'v2kc-empty';
      box.innerHTML = '<a class="v2kc-empty__btn" href="/collections/t-shirts">Shop T-shirts</a><a class="v2kc-empty__link" href="/collections/all">Or see everything</a>';
      emptyTitle.after(box);
    }
    const checkout = root.querySelector('.kaching-cart__checkout-button');
    if (checkout && !(checkout.nextElementSibling && checkout.nextElementSibling.classList.contains('v2kc-trust'))) {
      const ul = document.createElement('ul');
      ul.className = 'v2kc-trust';
      ul.setAttribute('role', 'list');
      ul.innerHTML = TRUST.map((t) => `<li>${t}</li>`).join('');
      checkout.after(ul);
    }
  };

  const itemKey = (item) => item.getAttribute('data-product-id') || item.getAttribute('data-product-handle');
  const sizeSelect = (item) => item.querySelector('select.kaching-cart-selector[data-option-name="Size"]');

  const markTouched = (e) => {
    const sel = e.target.closest && e.target.closest('.kaching-product-upsell-item select.kaching-cart-selector[data-option-name="Size"]');
    if (!sel) return;
    const item = sel.closest('.kaching-product-upsell-item');
    touched.add(itemKey(item));
    item.classList.remove('v2kc-needsize');
  };
  ['pointerdown', 'change', 'keydown'].forEach((t) => window.addEventListener(t, markTouched, true));

  window.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('#kaching-cart .kaching-product-upsell-item__add-to-cart');
    if (!btn) return;
    const item = btn.closest('.kaching-product-upsell-item');
    const sel = item && sizeSelect(item);
    if (!sel || sel.options.length < 2 || touched.has(itemKey(item))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    item.classList.add('v2kc-needsize');
  }, true);

  const start = () => {
    const root = document.getElementById('kaching-cart');
    if (!root) return false;
    apply(root);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; apply(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
    return true;
  };
  if (!start()) {
    const wait = new MutationObserver(() => { if (start()) wait.disconnect(); });
    wait.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
